/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import './TimelyAlert.scss';
import { ReactComponent as Close } from 'assets/icons/close.svg';
import { ReactComponent as WarningCircle } from 'assets/icons/warning-circle.svg';
import { contentConverter } from 'services/Content';
import { string, func } from 'prop-types';
import React from 'react';

const TimelyAlert = ({ id, messageText, hideTimelyAlert }) => {
  if (messageText) {
    return (
      <div id={id} className="timely-alert-container">
        <WarningCircle className="timely-alert-icon" />
        <span
          className="timely-alert-body"
          dangerouslySetInnerHTML={{
            __html: contentConverter.makeHtml(messageText)
          }}
        />
        <button
          id={id + '-close-button'}
          className="timely-alert-button"
          onClick={() => hideTimelyAlert(id)}>
          <Close className="timely-alert-close-button" />
        </button>
      </div>
    );
  }

  return null;
};

TimelyAlert.propTypes = {
  id: string.isRequired,
  messageText: string.isRequired,
  hideTimelyAlert: func.isRequired
};

export default TimelyAlert;
